import Backbone from 'backbone'
import template from './display-actions-editor.hbs'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import FormActions from './form-actions'

const DisplayActionsEditor = Backbone.View.extend({

	tagName: 'form',

	className: 'display-actions-editor',

	/**
	 * @param options.title {string} The title of the dialog
	 * @param options.bannerMsg {string} The banner message to display
	 * @param options.emptyMessage {string} The message to display when there
	 * are no actions
	 */
	initialize: function(options={}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		this.actions = new FormActions({
			model: this.model,
			statements: this.model.get('statements'),
			title: this.options.title,
			formView: this.formView,
			emptyMessage: this.options.emptyMessage
		})
		this.$('.dialog-body-content').append(this.actions.el)
		this.actions.render()

		this.formView.start()
		return this
	},

	context: function() {
		return {
			title: i18n.get('common.set2', this.options.title),
			bannerMsg: this.options.bannerMsg
		}
	},

	submit: function() {
		this.trigger('done', this.actions.getData())
	},

	autoRemove: true
})

export default DisplayActionsEditor

DisplayActionsEditor.__filename__ = 'forms/edit/display-actions-editor.js'
